// extracted by mini-css-extract-plugin
module.exports = {"afterSalesDesc":"_14911","title":"_7831","help":"_7245","arrow":"_14773"};